import { useDispatch, useSelector } from 'react-redux'
import { Box } from '@mui/material'
import SortByList from '../../../components/PageHelpers/Sort'
import { selectUserBatchStatusDetails } from '../../../redux/features/userBatchStatusDetails/userBatchStatusDetailsSlice'
import { filterStatusDetailsEmployeesList, sortStatusDetailsEmployeesList } from '../../../redux/features/userBatchStatusDetails/userBatchStatusDetailsThunk'
import ActiveFilters from '../../../components/PageHelpers/ActiveFilters'
import OfoqThemeBtn from '../../../components/Buttons/OfoqThemeBtn'
import FormModalContainer from '../../../components/Modals/FormModalContainer'
import UseTranslation from '../../../hooks/UseTranslation'
import MenuListMultiSelect from '../../../components/Forms/MenuListMultiSelect'

const Mobile = ({
  openModal, setOpenModal,
}) => {
  const batchStatusDetails = useSelector(selectUserBatchStatusDetails)
  const dispatch = useDispatch()

  const { t } = UseTranslation()
  const handleClose = () => {
    setOpenModal(false)
  }
  const clearAllFilters = () => {
    dispatch(filterStatusDetailsEmployeesList({ queries: 'clear' }))
  }

  return (
    <FormModalContainer
      modalTitle={`${t?.['Filter By']}`}
      modalState={openModal}
      handleClose={handleClose}
      cancelText={t?.close}
    >
      <Box sx={styles.filterBox}>
        <ActiveFilters
            store={batchStatusDetails}
            actionToDispatch={filterStatusDetailsEmployeesList}
            customStyle={styles.activeFilter}
          />
        <SortByList
          store={batchStatusDetails}
          actionToDispatch={sortStatusDetailsEmployeesList}
          customStyles={styles.sortBy} />

         <MenuListMultiSelect
            store={batchStatusDetails}
            actionToDispatch={filterStatusDetailsEmployeesList}
        />
        <OfoqThemeBtn
        name={`${t?.['Clear Filters']}`}
         onClick={clearAllFilters}
        customStyle={styles.clearFilters}
      />
      </Box>
    </FormModalContainer>
  )
}

const styles = {
  firstFilter: {
    marginInline: { xs: '0px', md: '10px' },
    marginBottom: '0px',
  },
  activeFilter: {
    flexWrap: 'wrap',
  },
  clearFilters: {
    width: { xs: '100%', sm: '0px' },
    maxWidth: { xs: '100%', md: '150px' },
    minWidth: { xs: '80px', sm: '0px' },
    marginTop: { xs: '30px', sm: 'unset' },
  },
  filterBox: {
    display: 'flex',
    gap: { xs: '5px', md: '23px' },
    width: '100%',
    flexDirection: { xs: 'column', sm: 'row' },
    my: '10px',
  },
  sortBy: {
    margin: { xs: '0 15px 15px', sm: '0 15px' },
    '& p': {
      fontSize: { xs: '14px', sm: '16px' },
    },
    '& button': {
      fontSize: { xs: '14px', sm: '16px' },
    },
  },
}
export default Mobile
